export default {
  data: ()=>({
    currency: "EUR",
  }),
  computed: {
    loggedInData() {
      return appRoot.loggedIn || {};
    },
  },
  methods: {
    formatPrice(price) {
      return (+price).toFixed(2) + " " + this.currency;
    },
    formatPriceRaw(price) {
      return (+price);
    },
    formatText(text) {
      text=(text || "")+"";
      text=text.replace(/\</g, "&lt;");
      text=text.replace(/\>/g, "&gt;");
      text=text.replace(/\n/g, "<br />");
      return text;
    },
    formatTitle(title) {
      title=this.formatText(title);
      title=title.replace(/\:/g, "<br />");
      return title;
    },
  },
}
